module.exports = __webpack_public_path__ + "img/enterprise_banner5.1c68fcdb.png";